import SignatureModal from './SignatureModal';

export default SignatureModal;